<script setup>

import { ref } from "vue";
import ListaDePedidosCartao from "./ListaDePedidos/ListaDePedidosCartao.vue";
import VisualizarPedidoDeCompraModal from "./VisualizarPedidoDeCompra/VisualizarPedidoDeCompraModal.vue";
import useUsuarioStore from "../../api/v2/stores/UsuarioStore.js";
import useColaboradorStore from "../../api/v2/stores/ColaboradorStore.js";

//==================================================================//
//=========================== User Store ===========================//
//==================================================================//

const usuarioStore = useUsuarioStore();

//==================================================================//
//======================== Colaborador Store =======================//
//==================================================================//

const colaboradorStore = useColaboradorStore(); 

//==================================================================//
//====================== Visualizando Pedido =======================//
//==================================================================//

const visualizandoPedido = ref(false);

//==================================================================//
//======================== Pedido de Compra ========================//
//==================================================================//

const pedidosDeCompra = ref([]);
const pedidoDeCompra = ref({});

//==================================================================//
//================== Altera Pedidos de Compra ======================//
//==================================================================//

const alteraPedidosDeCompra = (update=[])=>{

    pedidosDeCompra.value = update;

};

//==================================================================//
//================= Altera Pedido de Compra ========================//
//==================================================================//

const alteraPedidoDeCompra = (update={})=>{

    pedidoDeCompra.value = update

};

//==================================================================//
//================== Altera Visualizando Pedido ====================//
//==================================================================//

const alteraVisualizandoPedido = (update={})=>{

    visualizandoPedido.value = update.visualizandoPedido;
    alteraPedidoDeCompra(update?.pedidoDeCompra);

};

</script>

<template>

    <main
        class="c-main"
    >

        <ListaDePedidosCartao
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :pedidosDeCompra="pedidosDeCompra"
            :visualizandoPedido="visualizandoPedido"
            @update:pedidosDeCompra="alteraPedidosDeCompra"
            @update:pedidoDeCompra="alteraPedidoDeCompra"
            @update:visualizandoPedido="alteraVisualizandoPedido"
        ></ListaDePedidosCartao>
        
        <VisualizarPedidoDeCompraModal
            :usuarioStore="usuarioStore"
            :colaboradorStore="colaboradorStore"
            :pedidoDeCompra="pedidoDeCompra"
            :visualizandoPedido="visualizandoPedido"
            @update:visualizandoPedido="alteraVisualizandoPedido"
        ></VisualizarPedidoDeCompraModal>

    </main>

</template>

<style scoped>

.c-main{
    display: grid;
    gap: 15px;
}

</style>